import { ViewToolsState } from "lib/types/views/ViewToolsState";
import { useCesium } from "../../../components/elements/CesiumViewer/core/useCesium";
import {
  getViewToolsStateToolKey,
  viewsToolSet,
} from "lib/types/views/ViewToolsStateKey";

export function useViewTools() {
  const { toolManager } = useCesium();

  function captureToolsState(): ViewToolsState {
    const state: ViewToolsState = {
      version: 1,
      ...Object.fromEntries(
        viewsToolSet
          .values()
          .map(
            (tool) =>
              [
                tool,
                getViewToolsStateToolKey(tool),
                toolManager.captureToolState(tool),
              ] as const,
          )
          .filter(([tool, , toolState]) =>
            toolManager.isStateApplied(tool, toolState),
          )
          .map(([, key, state]) => [key, state] as const),
      ),
    };
    return state;
  }

  function restoreToolsState(state: ViewToolsState | null | undefined) {
    if (!state) return;
    viewsToolSet.forEach((tool) => {
      const key = getViewToolsStateToolKey(tool);
      if (key in state) toolManager.restoreToolState(tool, state[key]);
    });
  }

  return {
    captureToolsState,
    restoreToolsState,
  };
}
